import { Button, Empty, Flex, Typography } from 'antd';
import type { ReactNode } from 'react';

import { EmptyBoxImage } from '@/components';

import { EMPTY_STYLES } from './constants';

export type Props = {
  title?: string;
  description: string;
  ctaLabel?: string;
  onCtaClick?: () => void;
  children?: ReactNode;
};

const EmptySection = ({
  title,
  description,
  ctaLabel,
  onCtaClick,
  children
}: Props) => (
  <Empty
    styles={EMPTY_STYLES}
    description={
      <Flex vertical gap={8}>
        {title && <Typography.Title level={5}>{title}</Typography.Title>}
        <Typography.Text>{description}</Typography.Text>
      </Flex>
    }
    image={<EmptyBoxImage />}>
    {ctaLabel && (
      <Button type='primary' onClick={onCtaClick}>
        {ctaLabel}
      </Button>
    )}
    {children}
  </Empty>
);

export default EmptySection;
